<template>
  <div class="descIcon" :style="'margin-left:' + left + 'px;'">
    <h6>{{ descriptionIcons }}</h6> 
  </div>
</template>

<script>
export default {
  props: {
    descriptionIcons: {
      type: String
    },
    left: {
      type: Number
    }
  }
}
</script>

<style lang="scss" scoped>
  .descIcon {
    position: absolute;
    z-index: 999;
    background-color: rgb(80, 80, 80);
    color: white;
    top: 50px;
    padding: 5px;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/main/TooltipIcons.vue